// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useGetAllocationRequestRows } from '../../pages/registry/allocationRequest/useGetAllocationRequestRows';

export const useInboundAllocationRequestCount = () => {
  const { rows } = useGetAllocationRequestRows();
  return rows?.length || 0;
};
